// client/extensions/LiteralTab.ts
import { Extension } from "@tiptap/core";
var LiteralTab = {
  extensions: [
    Extension.create({
      name: "literalTab",
      addKeyboardShortcuts() {
        return {
          Tab: () => this.editor.commands.insertContent("\xA0\xA0\xA0\xA0")
        };
      }
    })
  ]
};
export {
  LiteralTab
};
